import config from '@/config';
import { usePageTitleStore } from '@/store';

export const usePageTitle = () => {
  return {
    getTitle,
    setTitle,
  };
};

const getTitle = () => {
  return usePageTitleStore().pageTitle;
};

const setTitle = title => {
  let prefix = '';
  if (config.env === 'staging') prefix = '[STAGING] ';
  if (config.env === 'development') prefix = '[DEV] ';

  title = title
    ? `${prefix}${title} | ${import.meta.env.VITE_APP_NAME}`
    : `${prefix}${import.meta.env.VITE_APP_NAME}`;

  usePageTitleStore().$patch({ pageTitle: title });
};
